var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-6 card-wrapper metadata"},[_c('card',[_c('div',{staticClass:"card-header"},[_c('h2',{staticClass:"card-title mb-0"},[_vm._v("\n                    Design decision\n                ")])]),_c('div',{staticClass:"card-body"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }